<template>
    <div class="main-overview">
        <!-- <div class="main-overview__sider"> -->
        <!-- <img class="bg" src="@/assets/sider-image.png" /> -->
        <!-- </div> -->

        <div class="main-overview__content">
            <img class="logo" src="@/assets/logo_taxifix.svg" />
            <div id="go-back" />

            <div class="main-overview__content--view">
                <router-view />
            </div>

            <OldSite v-if="isPopUpVisible" />
            <div v-else style="height: 100px" />

            <div class="version-container">
                {{ $t('generic.version') }}: {{appVersion}}
            </div>
        </div>
    </div>
</template>

<script>
import ServiceContainer from './service/ServiceContainer';
import AuthService from '@bnr-dev/auth-service/AuthService';
import * as Sentry from '@sentry/vue';
import OldSite from './components/OldSite.vue';
// import router from './router';

export default {
    name: 'App',
    components: {
        OldSite
    },
    provide() {
        return {
            authService: ServiceContainer.instance.authService,
            tokenService: ServiceContainer.instance.tokenService,
            moduleRedirectService:
                ServiceContainer.instance.moduleRedirectService,
            httpService: ServiceContainer.instance.httpService
        };
    },
    data() {
        return {
            isAuthenticated: ServiceContainer.instance.authService.isAuthenticated(),
            appVersion: process.env.VUE_APP_VERSION
        };
    },

    computed: {
        isPopUpVisible() {
            return false;
            // return router.currentRoute.value.name === 'SignIn';
        }
    },

    mounted() {
        ServiceContainer.instance.authService.addListener(
            AuthService.EVENTS.onAuthenticatedChanged,
            this._onAuthenticatedChanged.bind(this)
        );

        this.removeServiceWorkers();
    },

    methods: {
        removeServiceWorkers() {
            // Temporary code needed to remove service workers installed by taxifix modules
            if (!navigator || !navigator.serviceWorker) {
                return;
            }

            // Remove installed service workers.
            navigator.serviceWorker.getRegistrations().then(registrations => {
                for (const registration of registrations) {
                    console.log('removing ', registration)
                    registration.unregister();
                }
            });
        },

        _onAuthenticatedChanged(data) {
            console.log('onAuthenticatedChanged', data);
            this.isAuthenticated = data.isAuthenticated;
            if (this.isAuthenticated) {
                if (Sentry) {
                    Sentry.setUser(data.user);
                }
            } else {
                if (Sentry) {
                    Sentry.configureScope((scope) => scope.setUser(null));
                }
            }
            this.$router.replace({ name: 'SignIn' });
        }
    },
};
</script>

<style lang="scss">
@import '@/styles/colors';

.main-overview {
    display: flex;
    overflow: hidden;
    max-height: 100vh;

    &__sider {
        width: 50vw;
        height: 100vh;
        position: relative;

        .bg {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }

    &__content {
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .logo {
            position: absolute;
            margin: 40px 50px;
            top: 0;
            left: 0;
        }

        #go-back {
            display: flex;
            height: 60px;
            flex-direction: column;
            justify-content: flex-end;
            margin-left: 30px;
        }

        &--view {
            margin-bottom: 300px;
        }
    }
}

.version-container {
    font-size: 12px;
    color: $primary-color;
    position: absolute;
    bottom: 12px;
    left: 12px;
}
</style>
